import { render } from "./EditSectorModalComponent.vue?vue&type=template&id=6055e936&scoped=true"
import script from "./EditSectorModalComponent.vue?vue&type=script&lang=js"
export * from "./EditSectorModalComponent.vue?vue&type=script&lang=js"

import "./EditSectorModalComponent.vue?vue&type=style&index=0&id=6055e936&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6055e936"]])

export default __exports__